import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Twitter, Instagram, Youtube, Linkedin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="viriks-navy text-white mt-20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="inline-flex bg-white rounded-lg p-2 mb-4">
            <img src="/viriks-logo.jpg" alt="VIRIKS" className="h-8 w-auto" />
          </div>
          <p className="text-white/60 text-sm leading-relaxed">India's modern learning platform. Live classes, courses, test series and more — all in one place.</p>
          <div className="flex gap-3 mt-5">
            {[Facebook, Twitter, Instagram, Youtube, Linkedin].map((Icon, i) => (
              <a key={i} href="#" className="h-9 w-9 rounded-full bg-white/10 hover:bg-amber hover:text-navy flex items-center justify-center transition-colors">
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>
        <div>
          <h4 className="font-heading font-semibold mb-4">Learn</h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li><Link to="/courses" className="hover:text-amber">All Courses</Link></li>
            <li><Link to="/tests" className="hover:text-amber">Test Series</Link></li>
            <li><Link to="/store" className="hover:text-amber">VIRIKS Store</Link></li>
            <li><Link to="/verify" className="hover:text-amber" data-testid="footer-verify-link">Verify Certificate</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-semibold mb-4">Company</h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li><Link to="/page/about-us" className="hover:text-amber">About Us</Link></li>
            <li><Link to="/register?role=educator" className="hover:text-amber">Become an Educator</Link></li>
            <li><Link to="/register?role=content_seller" className="hover:text-amber">Become a Seller</Link></li>
            <li><Link to="/page/contact-us" className="hover:text-amber">Contact Us</Link></li>
            <li><Link to="/institute-franchise" className="hover:text-amber" data-testid="footer-franchise">Institute Franchise</Link></li>
            <li><Link to="/internship" className="hover:text-amber" data-testid="footer-internship">Internship Program</Link></li>
            <li><Link to="/institute-franchise/apply" className="hover:text-amber" data-testid="footer-franchise-apply">Franchise Application</Link></li>
            <li><Link to="/login" state={{ from: { pathname: "/institute" } }} className="hover:text-amber" data-testid="footer-partner-login">Partner Login</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-semibold mb-4">Legal</h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li><Link to="/page/privacy-policy" className="hover:text-amber">Privacy Policy</Link></li>
            <li><Link to="/page/terms" className="hover:text-amber">Terms & Conditions</Link></li>
            <li><Link to="/page/refund-policy" className="hover:text-amber">Refund Policy</Link></li>
            <li><Link to="/page/commission-policy" className="hover:text-amber" data-testid="footer-commission-policy">Commission Policy</Link></li>
            <li><Link to="/page/franchise-agreement" className="hover:text-amber" data-testid="footer-franchise-agreement">Franchise Agreement</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-sm text-white/50">
        © {new Date().getFullYear()} VIRIKS EdTech. All rights reserved.
      </div>
    </footer>
  );
}
